import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import DateRangeIcon from "@mui/icons-material/DateRange";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";

import useCrew from "../../hooks/useCrew";
import useUser from "../../hooks/useUser";
import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import { getUserCrewTrainings } from "../../api/training.deprecated";
import { convertDateTime } from "../../services/formatters";
import { OkIcon, ExpiredIcon } from "../../components/CourseStatusIcon";

const CheckerTrainings = ({ match, history }) => {
  const { t } = useTranslation();
  const [refresh, setRefresh] = useState(1);
  const { crew } = useCrew();
  const [userCrewTrainings, setUserCrewTrainings] = useState([]);
  const user = useUser();

  useEffect(() => {
    (async () => {
      const res = await getUserCrewTrainings("checker", user.id, crew.id);
      setUserCrewTrainings(res);
    })();
  }, [refresh]);

  return (
    <>
      <Typography variant="h4">{t("training_pages.checker_list")}</Typography>
      {userCrewTrainings ? (
        <TableComponent
          header={[
            { title: t("id"), style: { width: "5%" } },
            { title: t("training_pages.training") },
            { title: t("status") },
            { title: t("training_pages.e_learning") },
            { title: t("training_pages.classroom") },
            { title: t("training_pages.practical") },
            { title: t("training_pages.checker_tasks_done") },
            { title: t("actions") },
          ]}
          renderChildren={(userCrewTraining) => (
            <TableRow key={userCrewTraining.id}>
              <TableCell>{userCrewTraining.training_id}</TableCell>
              <TableCell>{userCrewTraining.displayname}</TableCell>
              <TableCell>{userCrewTraining.status}</TableCell>

              <TableCell>{userCrewTraining.is_e_learning ? t("yes") : t("no")}</TableCell>
              <TableCell>{userCrewTraining.is_classroom ? t("yes") : t("no")}</TableCell>
              <TableCell>{userCrewTraining.is_practical ? t("yes") : t("no")}</TableCell>

              <TableCell>{userCrewTraining.allDone ? <OkIcon /> : <ExpiredIcon />}</TableCell>

              <TableCell>
                <Button
                  icon={<PublishedWithChangesIcon />}
                  onClick={() => history.push(`/training-users/user/${userCrewTraining.training_id}`)}
                  title={t("training_pages.users_checking_progress")}
                />

                <Button
                  icon={<DateRangeIcon />}
                  onClick={() => history.push(`/trainings/schedule/checker/${userCrewTraining.training_id}`)}
                  title={t("training_pages.schedule_checker")}
                />

                <Button
                  icon={<LibraryAddCheckIcon />}
                  onClick={() =>
                    history.push(
                      `/trainings/checking-progress/checker/${userCrewTraining.training_id}/${userCrewTraining.instructor_complete}/${userCrewTraining.assessor_passed}/${userCrewTraining.checker_passed}`,
                    )
                  }
                  title={t("training_pages.checker_complete")}
                />
              </TableCell>
            </TableRow>
          )}
          search={["displayname", "fullname", "company_name"]}
          pagination
          items={userCrewTrainings}
        />
      ) : null}
    </>
  );
};

export default CheckerTrainings;
